import(/* webpackMode: "eager" */ "/opt/tcc-client/src/app/layout.tsx");
